import * as React from 'react';

export interface ContractResaleModalComponentProperties {
  readonly saveCallback: (redirectURL: string) => void;
  readonly newContractNumber: string;
  readonly oldContractNumber: string;
  readonly credit: string;
}

export class ContractResaleModalComponent extends React.Component<ContractResaleModalComponentProperties> {
  render() {
    return (
      <>
        <div className="row middle-xs center-xs">
          <h2>
            Based on the updated COE, the remaining premium from Contract #{this.props.oldContractNumber} is now{' '}
            {this.props.credit} to be applied to Contract #{this.props.newContractNumber}. An updated Demand Letter has
            been sent to Escrow.
          </h2>
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-resale/contract-resale-modal.component.tsx